import { Component, inject } from "@angular/core";
import { ConfirmDialogService } from "../../services/confirm-dialog.service";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.html",
  styleUrl: "./confirm-dialog.scss"
})
export class ConfirmDialog {
  protected readonly confirmDialogService = inject(ConfirmDialogService);

  onBackdropClick(): void {
    this.confirmDialogService.cancel();
  }

  onCancelClick(): void {
    this.confirmDialogService.cancel();
  }

  onConfirmClick(): void {
    this.confirmDialogService.confirm();
  }

  onDialogKeydown(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.confirmDialogService.cancel();
    }
  }
}
